export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/logo-same-day.cf76199e.svg","height":25,"width":95,"blurWidth":0,"blurHeight":0};